var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcRedo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6719 0.96875H12.9062C12.7148 0.96875 12.5781 1.13281 12.5781 1.32422L12.6328 4.00391C11.4297 2.17188 9.32422 0.96875 6.97266 0.996094C3.22656 0.996094 0.191406 4.05859 0.21875 7.77734C0.21875 11.5234 3.25391 14.5312 7 14.5312C8.72266 14.5312 10.3359 13.875 11.5391 12.8086C11.6758 12.6719 11.6758 12.4531 11.5391 12.3164L10.9922 11.7695C10.8828 11.6602 10.6914 11.6602 10.5547 11.7695C9.59766 12.6172 8.36719 13.1094 7 13.1094C4.01953 13.1094 1.64062 10.7305 1.64062 7.75C1.64062 4.79688 4.01953 2.39062 7 2.39062C9.16016 2.39062 11.0195 3.70312 11.8672 5.5625L8.42188 5.48047C8.23047 5.48047 8.09375 5.61719 8.09375 5.80859V6.54688C8.09375 6.73828 8.23047 6.875 8.42188 6.875H13.6719C13.8359 6.875 14 6.73828 14 6.54688V1.29688C14 1.13281 13.8359 0.96875 13.6719 0.96875Z",
    fill: "#0F86FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRedo);
export default __webpack_public_path__ + "static/media/ic-redo.8ce392ed9aa1d76d010336eda267e34c.svg";
export { ForwardRef as ReactComponent };